import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import clsx from 'clsx';
import Checkbox from 'components/Checkbox/Checkbox';
import { KEYS_FIELDS_CUSTOMER_MINI } from 'constants/materialAssessment';

import MiniTableBody from './components/MiniTableBody/MiniTableBody';

import type ISelectCustomerTable from './interfaces/ISelectCustomerTable';

import styles from './scss/SelectCustomerTable.module.scss';

function SelectCustomerTable({
  headerCells, selectedItems, setSelectedItems,
  vcCustomers, setUnSelectedItems,
  loadMoreVCCustomers, hasMoreVCCustomers,
}: Readonly<ISelectCustomerTable>) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.tableHeader}>
        {headerCells.map((cell) => (
          <div
            key={cell.id}
            className={`${styles.miniHeaderCell} ${
              cell.id === KEYS_FIELDS_CUSTOMER_MINI.CHECKBOX ? styles.checkboxColumn : ''
            }`}
          >
            {cell.id !== KEYS_FIELDS_CUSTOMER_MINI.CHECKBOX ? t(cell.label) : (
              <Checkbox
                name="unselectAll"
                checked={selectedItems?.length > 0}
                value={selectedItems?.length > 0 ? 'all' : ''}
                onChange={() => setUnSelectedItems()}
                className={clsx(styles.checkbox, [selectedItems.length === 0 && styles.disabled])}
                disabled={selectedItems.length === 0}
                isLineMark
              />
            )}
          </div>
        ))}
      </div>
      <InfiniteScroll
        dataLength={vcCustomers?.length || 0}
        next={loadMoreVCCustomers}
        hasMore={hasMoreVCCustomers || false}
        loader={false}
      >
        <div className={styles.tableBodyScroll}>
          <div className={styles.tableBody}>
            <div className={styles.miniTableContainer}>
              <MiniTableBody
                vcCustomers={vcCustomers}
                headerCellsMini={headerCells}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
              />
            </div>
          </div>
        </div>
      </InfiniteScroll>
    </div>
  );
}

export default SelectCustomerTable;
